import Tree from './component';

export default Tree;
